// src/components/AntdAppInitializer.jsx
//
// Mount this ONCE inside the antd <App> context.
// It grabs the message/notification/modal instances from
// useApp() and registers them globally so every component
// in the app can use globalMessage.success() etc. without
// needing the useApp() hook everywhere.

import { useEffect } from 'react';
import { App } from 'antd';
import {
  setMessageInstance,
  setNotificationInstance,
  setModalInstance,
} from '../utils/antdMessage';

const AntdAppInitializer = () => {
  const { message, notification, modal } = App.useApp();

  useEffect(() => {
    setMessageInstance(message);
    setNotificationInstance(notification);
    setModalInstance(modal);
  }, [message, notification, modal]);

  return null; // renders nothing
};

export default AntdAppInitializer;